import {
  DashboardProjectContext,
  useDashboardProjectDataContext,
} from 'domain/projects/newProject/context/DashboardProjectContext';
import { Grid2 as Grid } from '@mui/material';
import ProjectDashboardExpandedItemWrapper from '../List/ProjectDashboardExpandedItemWrapper';
import ProjectMainInfo from './ProjectMainInfo';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  getProjectManager,
  useProjectSecurityContext,
  useNewProjectUrl,
} from 'domain/shared/newProject';
import HealthcheckSystemIssues from 'domain/projects/newProject/shared/mainProjectSection/HealthcheckSystemIssues';
import ProjectBottomContent from './ProjectBottomContent';
import { LinkField } from 'framework/ui/field';
import ProjectExternalResources from './ProjectExternalResources';
import { DashboardItemWithSections } from 'domain/shared/core/dashboard';
import { orderExternalResources } from '../List/orderExternalResources';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';

const getExternalResources = (project: any) => {
  const resources = project?.resourcesData?.externalResources || project?.externalResources;
  return orderExternalResources(resources);
};

const ProjectItemExpandedContent = () => {
  const { data: project } = useDashboardProjectDataContext();
  const { isAccessGranted } = useProjectSecurityContext();
  const { isFeatureEnabled } = useFeatureToggle();
  const projectManager = getProjectManager(project);

  const { getControlsUrl, getOutcomesUrl, getProjectTeamUrl } = useNewProjectUrl();
  const projectPath =
    isAccessGranted(ACCESS_INFO_SECTIONS.CONTROL_PLANE, ACCESS_INFO_ACTIONS.VIEW) && isFeatureEnabled(Features.CONTROLS)
      ? getControlsUrl(project.id)
      : isAccessGranted(ACCESS_INFO_SECTIONS.BUSINESS_OUTCOME, ACCESS_INFO_ACTIONS.VIEW)
        ? getOutcomesUrl(project.id)
        : getProjectTeamUrl(project.id);
  const externalResources = getExternalResources(project);

  return (
    <ProjectDashboardExpandedItemWrapper bottomContent={<ProjectBottomContent />}>
      <Grid container columns={12} spacing={1}>
        <Grid size={9.5} sx={{ a: { fontWeight: 700 } }}>
          <LinkField isInternal value={projectPath} linkText={project.name} label="" />
        </Grid>
        <Grid size={2.5}>
          <ProjectExternalResources resources={externalResources} />
        </Grid>

        <Grid size={isAccessGranted(ACCESS_INFO_SECTIONS.HEALTH, ACCESS_INFO_ACTIONS.VIEW) ? { xs: 4.5 } : { xs: 9.5 }}>
          {isAccessGranted(ACCESS_INFO_SECTIONS.PROJECT_SUMMARY, ACCESS_INFO_ACTIONS.VIEW) && <ProjectMainInfo />}
        </Grid>

        <Grid size={isAccessGranted(ACCESS_INFO_SECTIONS.HEALTH, ACCESS_INFO_ACTIONS.VIEW) ? { xs: 2 } : { xs: 2.5 }}>
          <DashboardItemWithSections
            item={{
              ...project,
              id: project.id,
              projectManager,
            }}
            sectionsConfig={{
              people: { enabled: true, isOpenInNewTab: true },
            }}
          />
        </Grid>
        {isAccessGranted(ACCESS_INFO_SECTIONS.HEALTH, ACCESS_INFO_ACTIONS.VIEW) && (
          <Grid size={{ xs: 5 }}>
            <HealthcheckSystemIssues />
          </Grid>
        )}
      </Grid>
    </ProjectDashboardExpandedItemWrapper>
  );
};

const ProjectItemExpanded = ({ projectId }: { projectId: string }) => {
  return (
    <DashboardProjectContext id={projectId}>
      <ProjectItemExpandedContent />
    </DashboardProjectContext>
  );
};

export default ProjectItemExpanded;
